<template>
  <div >
    <el-dialog :title="`${title}品牌`"
               :visible.sync="dialogVisible"
               width="768px"
                 @close="handleClose"
              >
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="160px"
               class="demo-ruleForm scroll-auto">
                <el-form-item label="商标人名称:"
                      prop="company_name" v-if="this.$route.params.type==4">
          <el-input v-model="ruleForm.company_name"
                    placeholder="请输入公司全称"
                    clearable
                    @blur="getTrademarkInfo"
                    class="w400"></el-input>
        </el-form-item>
        <el-form-item label="品牌名称："
                      prop="brand_id">
          <el-select v-model="ruleForm.brand_id"
                     class="w400"
                     filterable
                     remote
                     reserve-keyword
                     placeholder="请输入关键词"
                     :remote-method="remoteMethod"
                     :loading="loading"
                     @change="getbrandName">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册/申请号："
                      prop="trademark_code">
           <el-select v-model="ruleForm.trademark_code"
                             class="w400"
                             filterable
                             placeholder="请选择商标"
                             @change="brandBind">
                    <el-option v-for="item in trademarkList"
                               :key="item.casenum"
                               :label="item.casenum"
                               :value="item.casenum"> </el-option>
                  </el-select>
        </el-form-item>
        <el-form-item label="商标名称："
                      prop="trademark_name">
          <el-input v-model="ruleForm.trademark_name"
                    placeholder="请输入商标名称"
                    clearable
                    class="w400"></el-input>
        </el-form-item>
        <el-form-item label="到期时间："
                      prop="valid_end_date">
          <el-date-picker v-model="ruleForm.valid_end_date"
                          :picker-options="expireTimeOption"
                          class="w400"
                          type="datetime"
                          placeholder="选择日期时间"
                          value-format="yyyy-MM-dd hh:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商标证："
                      prop="trademark_lce_type">
          <el-radio-group v-model="ruleForm.trademark_lce_type">
            <el-radio label="1">商标证 R</el-radio>
            <el-radio label="2">商标证 TM</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="file">
          <el-upload action="#"
                     accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                     list-type="picture-card"
                     :auto-upload="false"
                     :file-list="ruleForm.file"
                     :class="ruleForm.file.length == 1 ? 'mf' : ''"
                     :on-change="(file, fileList) => handleChange(file, fileList, 0)"
                     :on-remove="(file, fileList) => handleRemove(file, fileList, 0)"
                     :on-preview="(file) => handlePreview(file, 0)">
            <i slot="default"
               class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="authorization_file"
                      label="品牌授权书："
                      required
                      v-if="type == 4">
          <el-upload action="#"
                     list-type="picture-card"
                     accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                     :auto-upload="false"
                     :file-list="ruleForm.authorization_file"
                     :class="ruleForm.authorization_file.length == 1 ? 'mf' : ''"
                     :on-change="(file, fileList) => handleChange(file, fileList, 2)"
                     :on-remove="(file, fileList) => handleRemove(file, fileList, 2)"
                     :on-preview="(file) => handlePreview(file, 0)">
            <i slot="default"
               class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data () {
    return {
      expireTimeOption: {
        disabledDate (date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      trademarkList: [],
      dialogVisible: false,
      ruleForm: {
        company_name:'',
        brand_id: "",
        trademark_name: "",
        trademark_code: "",
        valid_end_date: "",
        trademark_lce_type: "1",
        file: [],
        file2:[],
        trademark_lce: "",
        authorization: "",
        authorization_file: [],
        brand_name: "",
      },
      rules: {
        company_name: [{ required: true, message: "请输入公司名称全称", trigger: "change" }],
        brand_id: [{ required: true, message: "请选择品牌名称", trigger: "change" }],
        trademark_name: [{ required: true, message: "请输入商标名称", trigger: "blur" }],
        trademark_code: [{ required: true, message: "请输入商标注册/申请号", trigger: "blur" }],
        valid_end_date: [{ required: true, message: "请选择到期时间", trigger: "change" }],
        trademark_lce_type: [{ required: true, message: "请选择商标证", trigger: "change" }],
        file: [{ required: true, message: "请上传商标", trigger: "change" }],
        authorization_file: [{ required: true, message: "请上传品牌授权书", trigger: "change" }],
      },
      loading: false,
      timer: null,
      options: [],
      opt_type: "create",
    };
  },
  props: ["type","title"],
  computed: {
    ...mapGetters(["getToken"]),
  },
  created () {
    this.getTrademarkInfo();
  },
  methods: {
    ...mapActions({
      getListbrand: "commodity/getListbrand", //品牌名称
      uploadFile: "commodity/uploadFile", //  图片上传
      trademarkInfo: "detect/trademarkInfo", //店铺商标
    }),

    brandBind () {
      if (this.trademarkList.length == 0) return;
      let obj = this.trademarkList.find((item) => {
        return this.ruleForm.trademark_code == item.casenum;
      });
      sessionStorage.setItem('classification',obj.classification)
      this.ruleForm.trademark_name = obj.brandmame;
      this.ruleForm.valid_end_date = obj.validity;
      this.ruleForm.trademark_lce = obj.tradeimg;
      this.ruleForm.file = [{ url: obj.tradeimg, name: obj.tradeimg }];
    },
    getTrademarkInfo () {
      let params = {
        token: this.getToken,
      };
      if(this.$route.params.type==4){
        params.company_name=this.ruleForm.company_name
      }
      this.trademarkInfo(params).then(({ data }) => {
        if (data.code == 1) {
          if (data.data.message) {
              this.$message.error(data.data.message);
          }
          if (data.data && data.data.zccontent) {
            this.trademarkList = data.data.zccontent.shangbiao;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    bindData (row, type) {
      this.opt_type = type;
      this.ruleForm = row;
      this.ruleForm.authorization_file = [{ url: this.ruleForm.authorization, name: this.ruleForm.authorization }];
      this.ruleForm.file = [{ url: this.ruleForm.trademark_lce, name: this.ruleForm.trademark_lce }];
      this.options = [
        {
          value: row.brand_id,
          label: row.brand_name,
        },
      ];
    },
    getbrandName (val) {
      this.ruleForm.brand_name = this.options.find((item) => {
        return val == item.value;
      }).label;
    },
    onSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("brandCreate", JSON.parse(JSON.stringify(this.ruleForm)), this.opt_type);
          this.handleClose();
          /* this.$message.success(`${this.opt_type == "edit" ? "编辑" : "添加"} 成功！`); */
        } else {
          return false;
        }
      });
    },
    handleClose () {
     if(this.title == "编辑") this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        brand_id: "",
        company_name:'',
        trademark_name: "",
        trademark_code: "",
        valid_end_date: "",
        trademark_lce_type: "1",
        file: [],
        trademark_lce: "",
        authorization: "",
        authorization_file: [],
      };
    },
    handlePreview (file, index, url) {
      this.$emit("imgShow", file, index, url);
    },
    //文件上传
    handleChange (file, fileList, index, talent_id) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      let i;
      switch (index) {
        case 0:
          this.ruleForm.file = fileList;
          if (this.ruleForm.file.length > 0) {
            this.$refs.ruleForm.clearValidate("file");
          }
          break;
        case 1:
          i = this.CategoryData.findIndex((item) => {
            return talent_id == item.talent_id;
          });
          this.$set(this.CategoryData[i], "file", fileList);
          break;
        case 2:
          this.ruleForm.authorization_file = fileList;
          if (this.ruleForm.authorization_file.length > 0) {
            this.$refs.ruleForm.clearValidate("file");
          }
          break;
        default:
          break;
      }
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          // console.log(res);
          this.$message.success("上传成功！");
          switch (index) {
            case 0:
              this.ruleForm.trademark_lce = res.data.formdata_details[0].urls;
              break;
            case 2:
              console.log(res.data.formdata_details[0].urls,'555')
              console.log( this.ruleForm.authorization ,'555')
              this.ruleForm.authorization = res.data.formdata_details[0].urls;
              break;
            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //品牌查询
    getSearchData (query) {
      this.getListbrand({ name: query }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.options = res.data.list.map((item) => {
            return { value: item.id, label: item.name };
          });
          // this.options.unshift({
          //     value: 0,
          //     label: "无",
          // });
        }
      });
    },
    //品牌查询
    remoteMethod (query) {
      if (query !== "") {
        this.loading = true;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.getSearchData(query);
        }, 800);
      } else {
        this.options = [
          // {
          //     value: 0,
          //     label: "无",
          // },
        ];
      }
    },
    //文件删除
    handleRemove (file, fileList, index, talent_id) {
      let i;
      switch (index) {
        case 0:
          this.ruleForm.file = [];
          break;
        case 2:
          this.ruleForm.authorization_file = [];
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w400 {
  width: 400px;
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
.demo-ruleForm {
  height: 560px;
}
</style>